<app-grid
  #grid
  [columnDefs]="columnDefs"
  [domLayout]="'autoHeight'"
  [isProjectOwnershipValid]="isProjectOwnershipValid"
  [rowData]="rowData"
  [rowSelection]="'multiple'"
  [suppressRowClickSelection]="true"
  [useAddAction]="isProjectOwnershipValid"
  [useDeleteAction]="isProjectOwnershipValid"
  [useSelectAll]="true"
  (deletedData)="onDelete($event)"
  (dropDownSelectionChangeEvent)="onDropdownChanged($event)"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onBtnSelectAllClicked()"
  (addEvent)="onAddNewRow($event)"
  (onInputNumberChanged)="onInputNumberChanged($event)"
/>
